import React from 'react';
import PropTypes from 'prop-types';
import entities from 'entities';
import { LabelWrapper, PreLabelContainer } from './styles';

const Label = ({
  label, color, display, size, weight, margin, withCursor, lineHeight, alignSelf, isTitleNarrowMedium, fontStyle, textAlignment, uppercase, preLabel, isHovered,
}) => (
  <LabelWrapper
    withCursor={withCursor}
    color={color}
    display={display}
    size={size}
    weight={weight}
    margin={margin}
    lineHeight={lineHeight}
    alignSelf={alignSelf}
    isTitleNarrowMedium={isTitleNarrowMedium}
    fontStyle={fontStyle}
    textAlignment={textAlignment}
    uppercase={uppercase}
    isHovered={isHovered}
  >
    {preLabel &&
      <PreLabelContainer>
        {preLabel}
      </PreLabelContainer>
    }
    {entities.decodeHTML(label)}
  </LabelWrapper>
);

Label.propTypes = {
  preLabel: PropTypes.any,
  label: PropTypes.any,
  color: PropTypes.string,
  display: PropTypes.string,
  size: PropTypes.number,
  weight: PropTypes.string,
  margin: PropTypes.any,
  withCursor: PropTypes.bool,
  lineHeight: PropTypes.number,
  alignSelf: PropTypes.string,
  isTitleNarrowMedium: PropTypes.bool,
  fontStyle: PropTypes.string,
  textAlignment: PropTypes.string,
  uppercase: PropTypes.bool,
  isHovered: PropTypes.bool,
};


export default Label;



// WEBPACK FOOTER //
// ./src/lib/components/shared/Label/index.js